import { render } from "./edit-sales.vue?vue&type=template&id=e4c61bf4&scoped=true"
import script from "./edit-sales.vue?vue&type=script&lang=js"
export * from "./edit-sales.vue?vue&type=script&lang=js"

import "./edit-sales.vue?vue&type=style&index=0&id=e4c61bf4&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c61bf4"]])

export default __exports__